module.exports = __webpack_public_path__ + "img/Toddlers.66a7c4f8.svg";